"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = StepThree;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Column = _interopRequireDefault(require("../../Column"));

var _getAssignFieldsData = _interopRequireDefault(require("../helpers/getAssignFieldsData"));

var _modifyCell = _interopRequireDefault(require("./modifyCell"));

var _fileFieldCell = _interopRequireDefault(require("./fileFieldCell"));

var _databaseFieldCell = _interopRequireDefault(require("./databaseFieldCell"));

var _assignFieldModal = _interopRequireDefault(require("./assignFieldModal"));

var _table = _interopRequireDefault(require("../styled/table"));

function StepThree(props) {
  var attributes = props.attributes,
      columns = props.columns,
      onAssignField = props.onAssignField,
      fieldsMap = props.fieldsMap,
      data = props.data,
      matchField = props.matchField;
  var previewData = data.slice(0, 3);

  var _useState = (0, _react.useState)([]),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      assignData = _useState2[0],
      setAssignData = _useState2[1];

  (0, _react.useEffect)(function () {
    setAssignData((0, _getAssignFieldsData["default"])({
      fieldsMap: fieldsMap,
      attributes: attributes,
      matchField: matchField
    }));
  }, [fieldsMap, attributes, matchField]);

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      isAssignFieldModalOpen = _useState4[0],
      setAssignFieldModalState = _useState4[1];

  var _useState5 = (0, _react.useState)(''),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      databaseFieldToAssign = _useState6[0],
      setDatabaseFieldToAssign = _useState6[1];

  var openAssignFieldModal = function openAssignFieldModal(field) {
    setAssignFieldModalState(true);
    setDatabaseFieldToAssign(field);
  };

  var closeAssignFieldModal = function closeAssignFieldModal() {
    setAssignFieldModalState(false);
  };

  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_table["default"], {
    keyField: "id",
    data: assignData
  }, /*#__PURE__*/_react["default"].createElement(_Column["default"], {
    header: "Modify",
    field: "fileField",
    component: function component(rowProps) {
      return (
        /*#__PURE__*/
        // eslint-disable-next-line react/jsx-props-no-spreading
        _react["default"].createElement(_modifyCell["default"], (0, _extends2["default"])({}, rowProps, {
          onClick: openAssignFieldModal
        }))
      );
    }
  }), /*#__PURE__*/_react["default"].createElement(_Column["default"], {
    header: "CSV titles",
    field: "fileField",
    component: _fileFieldCell["default"]
  }), /*#__PURE__*/_react["default"].createElement(_Column["default"], {
    header: "Database fields",
    field: "databaseField",
    component: _databaseFieldCell["default"]
  })), /*#__PURE__*/_react["default"].createElement(_assignFieldModal["default"], {
    attributes: attributes,
    isAssignFieldModalOpen: isAssignFieldModalOpen,
    onRequestClose: closeAssignFieldModal,
    columns: columns,
    databaseFieldToAssign: databaseFieldToAssign,
    onAssignField: onAssignField,
    fieldsMap: fieldsMap,
    data: previewData
  }));
}

StepThree.propTypes = {
  onAssignField: _propTypes["default"].func,
  fieldsMap: _propTypes["default"].object,
  data: _propTypes["default"].array,
  attributes: _propTypes["default"].object,
  matchField: _propTypes["default"].string,
  columns: _propTypes["default"].array
};
StepThree.defaultProps = {
  onAssignField: function onAssignField() {},
  fieldsMap: {},
  data: [],
  attributes: {},
  matchField: '',
  columns: []
};